import type { Component } from 'vue';

export const ImageModal: Component = defineAsyncComponent(() =>
  import('./ui/index.vue').then((m: { default: Component }) => m.default),
);
